import paper from 'paper';
import { Events } from '../../../utils/events';
import { TaggableCanvasAsset } from './taggableCanvasAsset';

export class NeuralaProject extends paper.Project {
    public events: Events;
    public setCursor: Function;
    public polygonResizingInProgress = false;
    public polygonMovingInProgress = false;

    constructor(params: any) {
        super(params);
    }

    public getAsset(): TaggableCanvasAsset {
        return this.layers['assetLayer'] ? this.layers['assetLayer'].children[0] : null;
    }

    public getAssetBounds(): paper.Rectangle {
        return this.layers['assetLayer']
            ? this.layers['assetLayer'].bounds
            : new paper.Rectangle(new paper.Point(0, 0), new paper.Size(0, 0));
    }
}



// WEBPACK FOOTER //
// ./src/components/workspace/objects/project.ts